import {call, put, takeEvery} from 'redux-saga/effects'
import Api from "../services/Api";

function* fetchMonthlyPlanning(action) {
  try {
    const monthlyPlanning = yield call(function () {
      return Api.get('/dealer/monthly-planning', {date: action.date});
    });
    yield put({type: 'FETCH_MONTHLY_PLANNING.SUCCESS', monthlyPlanning})
  } catch (error) {
    yield put({type: 'FETCH_MONTHLY_PLANNING.FAILURE', error})
  }
}

export function* watchFetchMonthlyPlanning() {
  yield takeEvery('FETCH_MONTHLY_PLANNING.REQUEST', fetchMonthlyPlanning);
}

function* saveMonthlyPlanning(action) {
  try {
    const monthlyPlanning = yield call(function () {
      return Api.post('/dealer/monthly-planning', action.body)
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message: 'save.success'}});
    yield put({type: 'SAVE_MONTHLY_PLANNING.SUCCESS', monthlyPlanning});
  } catch (error) {
    yield put({type: 'SAVE_MONTHLY_PLANNING.FAILURE', error});
  }
}

export function* watchSaveMonthlyPlanning() {
  yield takeEvery('SAVE_MONTHLY_PLANNING.REQUEST', saveMonthlyPlanning)
}
